<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({ name: 'BotVariableDetail', params: { botId: item.bot, vairableId: item._id } })
			},
			items: [
				{ header: 'Nom', value: (item) => item.name, sort: 'name', filter: { name: 'name' } },
				{ header: 'Clef', value: (item) => item.key, sort: 'key', filter: { name: 'key' } },
				{ header: 'Type',
          value: (item) => item.bot && item.variableType === 'user' ? `specific:${item.variableType}` : item.variableType,
        sort: 'variableType',
        filter: {
					type: 'multi-select',
					values: ['user', 'navigation'],
					name: 'variableType'
					} },
				{
					header: 'Groupe',
					value: (item) => {
						if (!item.subBot) {
							return ''
						}
						if (!this.$store.getters.bot.subBots) {
							return item.subBot
						}

						let subBot = this.$store.getters.bot.subBots.find(sub => sub._id === item.subBot)
						return subBot ? subBot.name : item.subBot
					},
					sort: false,
					filter: {
						type: 'multi-select',
						values: this.$store.getters.bot.subBots,
						itemText: 'name',
						itemValue: '_id'
					},
					cellClick: (item) => {
						if (item.subBot) {
							this.$router.push({ name: 'SubBotDetail', params: { botId: item.bot, subBotId: item.subBot } })
						}
					}
				}
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/botVariables/botVariable.list.vue